query DistinctEnvironments($days: Int!) {
  score_web_products(timeframe_days_eq: { value: [$days] }) {
    environment
  }
}
